export const GIT_HASH = JSON.parse(import.meta.env.__GIT_HASH__ ?? '""');
export const GIT_TAG = JSON.parse(import.meta.env.__GIT_TAG__ ?? '""');

export const STAGE = JSON.parse(import.meta.env.__STAGE__ ?? '""');
export const REGION = JSON.parse(import.meta.env.__REGION__ ?? '""');

export const DEV = import.meta.env.__DEV__;
export const GA = import.meta.env.__GA__;
export const GTM = import.meta.env.__GTM__;
export const BRAZE = import.meta.env.__BRAZE__;
export const FACEBOOK = import.meta.env.__FACEBOOK__;
export const COMPERIA = import.meta.env.__COMPERIA__;
